import { flatten } from 'lodash'
import { createSelector } from 'reselect'

import { currentUser } from '../../../redux/auth/selectors'
import {
  validateBusinessAddress, validateBusinessInformation,
  validateContactInformation,
  validatePaymentInformation,
  validateUserConfirmation
} from '../helpers/validators'
import { State } from './reducers/activationRegistrationUIReducer'

export interface NestedState {
  activationUIReducer: {
    activationRegistrationUIReducer: State
  }
}

export const getBusinessInformation = (state: NestedState) => (
  state.activationUIReducer.activationRegistrationUIReducer.businessInformation)
export const getBusinessAddress = (state: NestedState) => (
  state.activationUIReducer.activationRegistrationUIReducer.businessAddress)
export const getContactInformation = (state: NestedState) => (
  state.activationUIReducer.activationRegistrationUIReducer.contactInformation)
export const getPaymentInformation = (state: NestedState) => (
  state.activationUIReducer.activationRegistrationUIReducer.paymentInformation)
export const showValidationErrors = (state: NestedState) => (
  state.activationUIReducer.activationRegistrationUIReducer.showValidationErrors)
export const getSelectedPlan = (state: NestedState) => (
  state.activationUIReducer.activationRegistrationUIReducer.selectedPlan)
export const getIsShowSuccessPage = (state: NestedState) => (
  state.activationUIReducer.activationRegistrationUIReducer.showSuccessPage)
export const getIsLoading = (state: NestedState) => (
  state.activationUIReducer.activationRegistrationUIReducer.isLoading)
export const getIsChangeCardMode = (state: NestedState) => (
  state.activationUIReducer.activationRegistrationUIReducer.isChangeCardMode)
export const accountDetailsSelector = (state: NestedState) => (
  state.activationUIReducer.activationRegistrationUIReducer)
export const isUpdateSucceeded = (state: NestedState) => (
  state.activationUIReducer.activationRegistrationUIReducer.isUpdateSucceeded)
export const userHasNecessaryRightConfirmationSelector = (state: NestedState) => (
  state.activationUIReducer.activationRegistrationUIReducer.userHasNecessaryRightConfirmation)
export const isShouldSkipCRMFlow = (state: NestedState) => (
  state.activationUIReducer.activationRegistrationUIReducer.isShouldSkipCRMFlow)

export const getUserEmail = createSelector([currentUser], currentUser => currentUser.email)

export const invalidFields = createSelector(
  [
    getBusinessInformation,
    getBusinessAddress,
    getContactInformation,
    getPaymentInformation,
    userHasNecessaryRightConfirmationSelector
  ],
  (
    businessInformation,
    businessAddress,
    contactInformation,
    paymentInformation,
    userConfirmation
  ) => {
    const validationResults: any[] = []

    const businessInformationValidationResult = validateBusinessInformation(businessInformation)
    pushIfNotEmpty(validationResults, businessInformationValidationResult)

    const validateBusinessAddressResult = validateBusinessAddress(businessAddress)
    pushIfNotEmpty(validationResults, validateBusinessAddressResult)

    const validateContactInformationResult = validateContactInformation(contactInformation)
    pushIfNotEmpty(validationResults, validateContactInformationResult)

    const validatePaymentInformationResult = validatePaymentInformation(paymentInformation)
    pushIfNotEmpty(validationResults, validatePaymentInformationResult)

    const validateUserConfirmationResult = validateUserConfirmation(userConfirmation)
    pushIfNotEmpty(validationResults, validateUserConfirmationResult)

    return flatten(validationResults)
  }
)

const pushIfNotEmpty = (array: any[], arrToBePushed: any): any[] => {
  if (arrToBePushed.length) {
    array.push(arrToBePushed)
  }
  return array
}
